import { render, staticRenderFns } from "./rightBottom.vue?vue&type=template&id=aa83c35e&scoped=true"
import script from "./rightBottom.vue?vue&type=script&lang=js"
export * from "./rightBottom.vue?vue&type=script&lang=js"
import style0 from "./rightBottom.vue?vue&type=style&index=0&id=aa83c35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa83c35e",
  null
  
)

export default component.exports